import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { ApiResponse } from '@app/models/api.model'
import { Branch } from '@models/branch.model';
import { Voucher } from '@models/voucher.model';
@Injectable({
  providedIn: 'root'
})
export class BuyerintQrService {
  private http = inject(HttpClient);

  private urlApi: string;
  private apiKey: string;

  constructor() {
    this.urlApi = environment.urlApiDev;
    this.apiKey = environment.buyerIntApiKey;
  }

  getBranches(documentType: string, documentNumber: string): Observable<ApiResponse<Branch[]>> {
    return this.http.get<ApiResponse<any>>(`${this.urlApi}/buyerint/Qr/traerSucursales`, {
      params: {
        tipoDocumento: documentType,
        documento: documentNumber
      },
      headers: {
        authorization: `Basic ${btoa(this.apiKey)}`
      }
    }).pipe(
      map((resp) => ({
        ...resp,
        data: (resp.data || []).map((item: any) => Branch.fromResponse(item))
      }))
    )
  }

  getQrCodeImage(documentType: string, documentNumber: string, codigoConsulta: string): Observable<Blob> {
    return this.http.get(`${this.urlApi}/buyerint/Qr/generar`, {
      params: {
        tipoDocumento: documentType,
        documento: documentNumber,
        consulta: codigoConsulta
      },
      headers: {
        authorization: `Basic ${btoa(this.apiKey)}`
      },
      responseType: 'blob'
    });
  }

  getQrCodePdf(documentType: string, documentNumber: string, codigoConsulta: string): Observable<ApiResponse<Voucher>> {
    return this.http.get<ApiResponse<any>>(`${this.urlApi}/buyerint/Qr/descargar-comprobante`, {
      params: {
        tipoDocumento: documentType,
        documento: documentNumber,
        consulta: codigoConsulta
      },
      headers: {
        authorization: `Basic ${btoa(this.apiKey)}`
      }
    }).pipe(
      map((resp) => ({
        ...resp,
        data: Voucher.fromResponse(resp.data)
      }))
    )
  }

}
